import React from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';

import Routes from 'Routes';

import Roboto from 'assets/fonts/Roboto-Regular-webfont.ttf';
import { requestForToken } from 'init-firebase';

const roboto = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 500,
  src: `url(${Roboto}) format('opentype')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const defaultTheme = createTheme();

const theme = createTheme({
  palette: {
    primary: {
      main: '#233C97',
    },
    secondary: {
      main: '#f54c3f',
    },
    background: {
      default: '#FFFFFF',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
    fontFamily: `"Roboto", ${defaultTheme.typography.fontFamily}`,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [roboto],
        '*::-webkit-scrollbar': {
          height: 5,
          width: 5,
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#CBD1D7',
          borderRadius: 7,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Routes />
    </ThemeProvider>
  );
}

export default App;
